<template>
  <div>
    <el-form>
      <el-form-item>
        公司名称：
        <el-input style="width:50%" v-model="tc_name"></el-input>
      </el-form-item>
      <el-form-item>
        状态：
        <template slot-scope="scope">
          <el-switch
            v-model="tc_state"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="0"
            :inactive-value="1"

            style="margin-right: 10px">
          </el-switch>
        </template>
      </el-form-item>
      <el-button @click="insertCompany">保存</el-button>
    </el-form>
  </div>
</template>

<script>
  export default {
    inject:['reload'],
    name: 'AddAdmin',
    data(){
      return {
        rohs: true,
        tc_name:'',
        tc_state:null
      }
    },
    methods:{
      insertCompany(){
        this.$inbound.post({
          interfaceId: 'company/insertCompany',
          data:{
            tc_name:this.tc_name,
            tc_state:this.tc_state,
          },
        }).then(response => {
          this.reload()
        }).catch(error => {
          console.log(error)
        })
      },
      close (){
        this.$emit('close')
      }
    }

  }
</script>
